var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseRed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M404.252138,1573.00003 L408.887115,1568.36505 C409.313771,1567.93839 409.313771,1567.24665 408.887115,1566.82005 C408.46046,1566.3934 407.768778,1566.3934 407.342123,1566.82005 L402.707084,1571.4551 L398.072045,1566.81999 C397.64539,1566.39334 396.953708,1566.39334 396.527052,1566.81999 C396.100458,1567.24665 396.100458,1567.93839 396.527052,1568.36499 L401.162091,1572.99997 L396.527052,1577.63501 C396.100458,1578.06167 396.100458,1578.75341 396.527052,1579.18001 C396.953708,1579.60666 397.64539,1579.60666 398.072045,1579.18001 L402.707084,1574.54496 L407.342123,1579.18001 C407.768717,1579.60666 408.46046,1579.60666 408.887115,1579.18001 C409.313771,1578.75335 409.313771,1578.06167 408.887115,1577.63501 L404.252138,1573.00003 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A4-Copy",
    transform: "translate(-396.000000, -1566.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icCloseRed",
    fill: "#FF0400",
    fillRule: "nonzero",
    transform: "translate(402.707107, 1573.000000) rotate(-89.000000) translate(-402.707107, -1573.000000) ",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseRed);
export default __webpack_public_path__ + "static/media/icCloseRed.f8eb9e86d7030d14a37e1eeb438f40ad.svg";
export { ForwardRef as ReactComponent };